import React from 'react';
import { Box, Checkbox, Copy, Label } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { updateCalculatorField, selectFinancialCalculator } from '../../core/reducers/financialCalculators';
import themeStyles from './TrimPaymentCheckbox.styles';
import { useAppSelector } from '../../core/utils';
const Title = themeStyles.apply(Copy, 'Title');
const Wrapper = themeStyles.apply(Box, 'Wrapper');
const CheckboxLabel = themeStyles.apply(Label, 'CheckboxLabel');
const CheckboxWrapper = themeStyles.apply(Box, 'CheckboxWrapper');
const TrimPaymentCheckbox = ({ componentName = 'trim-payment', calculatorId, }) => {
    var _a;
    const { overriddenIsSellingProvince, includeFees } = (_a = useAppSelector(state => selectFinancialCalculator(state, calculatorId))) !== null && _a !== void 0 ? _a : {};
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const handleFeeClick = () => {
        const updateField = overriddenIsSellingProvince && includeFees
            ? {
                includeFees: false,
                overriddenIsSellingProvince: false,
            }
            : {
                overriddenIsSellingProvince: !overriddenIsSellingProvince,
            };
        dispatch(updateCalculatorField({ id: calculatorId, field: updateField }));
    };
    const handleAddTaxesClick = () => {
        const updateField = !includeFees
            ? {
                includeFees: true,
                overriddenIsSellingProvince: true,
            }
            : {
                includeFees: false,
            };
        dispatch(updateCalculatorField({ id: calculatorId, field: updateField }));
    };
    return (React.createElement(Box, { "data-component-name": `${componentName}-checkbox`, "data-testid": "cy-trim-payment-checkbox" },
        React.createElement(Title, { size: "subheading", fontWeight: "bold", "data-testid": "cy-trim-payment-checkbox-title" }, t('Shared.Common.viewPricingLabel')),
        React.createElement(Wrapper, { mb: "xs", "data-testid": "cy-trim-payment-checkbox-fee" },
            React.createElement(CheckboxWrapper, null,
                React.createElement(Checkbox, { id: "fee", containerSize: "small", ariaLabel: t('Shared.Common.includeFreightCheckboxLabel'), value: "fee", name: "fee", checked: overriddenIsSellingProvince, onClick: handleFeeClick })),
            React.createElement(CheckboxLabel, { htmlFor: "fee" }, t('Shared.Common.includeFreightCheckboxLabel'))),
        React.createElement(Wrapper, { mb: ['l', 'l', 'm'], "data-testid": "cy-trim-payment-checkbox-tax" },
            React.createElement(CheckboxWrapper, null,
                React.createElement(Checkbox, { containerSize: "small", id: "tax", ariaLabel: t('Shared.Common.includeTaxesCheckboxLabel'), value: "tax", name: "tax", checked: includeFees, onClick: handleAddTaxesClick })),
            React.createElement(CheckboxLabel, { htmlFor: "tax" }, t('Shared.Common.includeTaxesCheckboxLabel')))));
};
export default TrimPaymentCheckbox;
